export default __webpack_public_path__ + "static/media/facebook.6fa15b99.svg";